module.exports = __webpack_public_path__ + "static/img/size.b6294c11.svg";